// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sc-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}
.sc-add {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 0;
  background: none;
  padding: 0;
  font-size: 0.84rem;
  font-weight: 600;
  color: var(--brand);
  cursor: pointer;
}
.sc-add:hover {
  text-decoration: underline;
}
.sc-file {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
}

.sc-thumbs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}

.sc-thumb {
  position: relative;
  width: 64px;
  height: 64px;
  border-radius: var(--radius-sm);
  overflow: hidden;
  border: 1px solid var(--border);
}

.sc-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.sc-thumb button {
  position: absolute;
  top: 3px;
  right: 3px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border: 0;
  border-radius: 50%;
  background: rgba(30, 27, 75, 0.72);
  color: #fff;
  cursor: pointer;
}

.sc-item {
  display: flex;
  gap: 14px;
  padding: 14px 16px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow-xs);
}

.sc-cover {
  flex-shrink: 0;
  width: 88px;
  height: 88px;
  border-radius: var(--radius-sm);
  object-fit: cover;
}

.sc-body {
  flex: 1 1;
  min-width: 0;
}

.sc-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 4px;
}

.sc-top h3 {
  font-size: 0.98rem;
  font-weight: 700;
  color: var(--text);
}

.sc-body > p {
  font-size: 0.84rem;
  line-height: 1.55;
  color: var(--muted);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.sc-price {
  font-family: var(--font-display);
  font-weight: 700;
  color: var(--brand);
}

.sc-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}

.sc-actions .f-ghost {
  padding: 8px 12px;
  font-size: 0.82rem;
}

@media (max-width: 560px) {
  .sc-item {
    flex-direction: column;
  }
  .sc-cover {
    width: 100%;
    height: 140px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/provider/ServiceCatalog.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,aAAa;EACf;AACF","sourcesContent":[".sc-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 8px;\n}\n.sc-add {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border: 0;\n  background: none;\n  padding: 0;\n  font-size: 0.84rem;\n  font-weight: 600;\n  color: var(--brand);\n  cursor: pointer;\n}\n.sc-add:hover {\n  text-decoration: underline;\n}\n.sc-file {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.sc-thumbs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 10px;\n}\n\n.sc-thumb {\n  position: relative;\n  width: 64px;\n  height: 64px;\n  border-radius: var(--radius-sm);\n  overflow: hidden;\n  border: 1px solid var(--border);\n}\n\n.sc-thumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.sc-thumb button {\n  position: absolute;\n  top: 3px;\n  right: 3px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border: 0;\n  border-radius: 50%;\n  background: rgba(30, 27, 75, 0.72);\n  color: #fff;\n  cursor: pointer;\n}\n\n.sc-item {\n  display: flex;\n  gap: 14px;\n  padding: 14px 16px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow-xs);\n}\n\n.sc-cover {\n  flex-shrink: 0;\n  width: 88px;\n  height: 88px;\n  border-radius: var(--radius-sm);\n  object-fit: cover;\n}\n\n.sc-body {\n  flex: 1;\n  min-width: 0;\n}\n\n.sc-top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 4px;\n}\n\n.sc-top h3 {\n  font-size: 0.98rem;\n  font-weight: 700;\n  color: var(--text);\n}\n\n.sc-body > p {\n  font-size: 0.84rem;\n  line-height: 1.55;\n  color: var(--muted);\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.sc-price {\n  font-family: var(--font-display);\n  font-weight: 700;\n  color: var(--brand);\n}\n\n.sc-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 10px;\n}\n\n.sc-actions .f-ghost {\n  padding: 8px 12px;\n  font-size: 0.82rem;\n}\n\n@media (max-width: 560px) {\n  .sc-item {\n    flex-direction: column;\n  }\n  .sc-cover {\n    width: 100%;\n    height: 140px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
